module.exports = [
  {
    title: 'Краткое наименование',
    key: 'name'
  },
  {
    title: 'Дата Обновления',
    key: 'modified_date'
  }
]
